export const hasPermission = (user, section, action) => {
  if (!user || !user.roles) return false;
  
  // System Admins have full access to everything
  if (user.roles.includes('sys_admin') || user.roles.includes('System Administrator')) return true;

  if (!user.permissions) return false;

  // Find the permission for the specific section
  const sectionPerm = user.permissions.find(p => 
    p.section_name.toLowerCase() === section.toLowerCase() ||
    p.section_name.toLowerCase().includes(section.toLowerCase())
  );

  if (!sectionPerm) return false;

  // Map action to specific permission field
  const actionMap = {
    view: 'can_view',
    add: 'can_add',
    edit: 'can_edit',
    delete: 'can_delete',
    update: 'can_edit' // Mapping update to edit for convenience
  };

  const field = actionMap[action.toLowerCase()];
  return field ? parseInt(sectionPerm[field]) === 1 : false;
};
